import { call, takeEvery, put } from 'redux-saga/effects';
import { notificationsAdd } from 'virtues-bootstrap';
import { getUniqId } from 'utilities';

import {
  redcapDictionary,
  requestRedcapDictionarySuccess,
  updateRedcapDictionary,
} from 'store/actionCreators/dictionary';

import { requestRedcapDictionary } from 'services/api/request';

export function* onGetRedcapDictionary() {
  try {
    const {
      data: { item },
    } = yield call(requestRedcapDictionary);

    if (item) {
      yield put(requestRedcapDictionarySuccess({ item }));
    }
  } catch (error) {
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'danger',
        title: 'error',
        description: error.toString(),
      }),
    );
  }
}

export function* handleUpdateDictionary({ payload: updatedDictionary }) {
  try {
    yield call(updateRedcapDictionary(updatedDictionary));
  } catch (error) {
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'danger',
        title: 'error',
        description: error.toString(),
      }),
    );
  }
}

export default function*() {
  yield takeEvery(redcapDictionary, onGetRedcapDictionary);
  yield takeEvery(updateRedcapDictionary, handleUpdateDictionary);
}
